import { useNavigate } from "react-router";
import useUserState from "~/stores/user";
import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui";
import { useTranslation } from "react-i18next";
import { CompanySelector } from "../common/company-selector";
import { getConfig, updateBaseUrl } from "lib/config";
import { useState } from "react";
import { ThemePicker } from "../common/theme-picker";
import useSettingState from "~/stores/setting";
import useUiNodeState from "~/stores/ui/node";

export function SessionSettingsForm({
  onSubmit = () => {},
}: {
  onSubmit: () => void;
}) {
  const { t } = useTranslation();
  const userState = useUserState();
  const settingState = useSettingState();
  const uiNodeState = useUiNodeState();

  const navigate = useNavigate();
  const logout = () => {
    // Clear the state information from the stores
    userState.reset();
    settingState.reset();
    uiNodeState.reset();

    navigate("/login", { replace: true });
    onSubmit();
  };

  const companyChange = (companyId: number | null) => {
    if (companyId === null) return;
    onSubmit();
  };

  return (
    <div className="flex flex-col justify-center align-center">
      <CompanySelector onChange={companyChange} />
      <ThemePicker />
      <div className="my-4 border-t" />
      <Button variant="outline" onClick={logout}>
        {t("common.logout")}
      </Button>
    </div>
  );
}

export function BaseUrlForm() {
  const { t } = useTranslation();
  const config = getConfig();
  const [baseUrl, setBaseUrl] = useState(config.BASE_URL);
  const hasBaseUrlFeature = config.FEATURES?.includes("BASEURL") ?? false;

  const baseUrls = [
    { title: "Local", value: "http://localhost:5000/api" },
    { title: "Cloud", value: "https://cloudapi.sensor-online.se/api" },
    { title: "Anderssons El", value: "https://soapi.anderssonsel.se/api" },
    { title: "Sweco", value: "https://api.swamp.se/api" },
  ];

  const handleChange = (value: string) => {
    updateBaseUrl(value);
    setBaseUrl(value);
  };

  // Hide if feature not enabled
  if (!hasBaseUrlFeature) return null;

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-1" htmlFor="baseUrl">
        {t("settings.base_url")}
      </label>
      <Select
        defaultValue="http://localhost:5000/api"
        value={baseUrl}
        onValueChange={(value) => {
          handleChange(value);
        }}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>

        <SelectContent>
          {baseUrls.map((w) => (
            <SelectItem key={w.value} value={w.value}>
              {w.title}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
